
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "toggle"
    }}>{`Toggle`}</h1>
    <p>{`Toggle component is a styled wrapper to a checkbox / label pair. It accepts a "checked" prop, and a "onToggle" prop that is triggered by the checkbox onChange event.`}</p>
    <h3 {...{
      "id": "default-example"
    }}>{`Default example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [checked, setChecked] = React.useState(false);
  return (
    <Toggle
      checked={checked}
      aria-label="Toggle Label"
      onChange={(e) => {
        setChecked(e.target.checked);
      }}
    />
  );
};
`}</code></pre>
    <h3 {...{
      "id": "disabled-example"
    }}>{`disabled example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`() => {
  const [checked, setChecked] = React.useState(false);
  return (
    <>
      <View direction="row" spacing={2}>
        <View
          extend={{
            padding: 10,
          }}
        >
          <Toggle
            disabled
            checked={checked}
            onChange={(e) => {
              setChecked(e.target.checked);
            }}
          />
        </View>
        <View
          extend={{
            padding: 10,
          }}
        >
          <Toggle
            disabled
            checked={true}
            onChange={(e) => {
              setChecked(e.target.checked);
            }}
          />
        </View>
      </View>
    </>
  );
};
`}</code></pre>
    <h3 {...{
      "id": "props---toggle"
    }}>{`Props - Toggle`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default Value`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`aria-label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defines a string value that labels the current element.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string ｜ undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`checked`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean ｜ undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`disabled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean ｜ undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`onChange`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`ChangeEventHandler<HTMLInputElement>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;